export default function Social() {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style={{ enableBackground: 'new 0 0 512 512' }}
      xmlSpace="preserve"
      className="w-8 h-8 fill-current text-white"
    >
      <g>
        <g>
          <path
            d="M477.867,102.4c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133S512,155.358,512,136.533
			C512,117.709,496.691,102.4,477.867,102.4z M477.867,153.6c-9.412,0-17.067-7.654-17.067-17.067
			c0-9.412,7.654-17.067,17.067-17.067s17.067,7.654,17.067,17.067C494.933,145.946,487.279,153.6,477.867,153.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M34.133,384C15.309,384,0,399.309,0,418.133s15.309,34.133,34.133,34.133c18.825,0,34.133-15.309,34.133-34.133
			S52.958,384,34.133,384z M34.133,435.2c-9.412,0-17.067-7.654-17.067-17.067s7.654-17.067,17.067-17.067
			c9.412,0,17.067,7.654,17.067,17.067S43.546,435.2,34.133,435.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M461.321,113.186l-73.617-35.541c-4.25-2.057-9.344-0.265-11.392,3.977c-2.048,4.241-0.265,9.344,3.977,11.392
			l73.617,35.541c1.195,0.58,2.458,0.853,3.703,0.853c3.174,0,6.221-1.775,7.688-4.83
			C467.345,120.337,465.562,115.234,461.321,113.186z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M384,443.733c-18.825,0-34.133,15.309-34.133,34.133S365.175,512,384,512c18.825,0,34.133-15.309,34.133-34.133
			S402.825,443.733,384,443.733z M384,494.933c-9.412,0-17.067-7.654-17.067-17.067S374.588,460.8,384,460.8
			c9.412,0,17.067,7.654,17.067,17.067S393.412,494.933,384,494.933z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M367.454,454.52l-73.617-35.541c-4.25-2.057-9.344-0.273-11.392,3.977c-2.048,4.241-0.265,9.344,3.977,11.392
			l73.617,35.541c1.195,0.58,2.458,0.853,3.703,0.853c3.174,0,6.221-1.775,7.689-4.83
			C373.478,461.67,371.695,456.568,367.454,454.52z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M256,230.4c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133
			c18.825,0,34.133-15.309,34.133-34.133C290.133,245.709,274.825,230.4,256,230.4z M256,281.6c-9.412,0-17.067-7.654-17.067-17.067
			c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C273.067,273.946,265.412,281.6,256,281.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M240.998,242.142l-56.55-44.075c-3.721-2.876-9.079-2.236-11.981,1.485c-2.893,3.721-2.236,9.079,1.485,11.981
			l56.55,44.075c1.562,1.212,3.405,1.801,5.24,1.801c2.543,0,5.052-1.126,6.741-3.285
			C245.376,250.402,244.719,245.043,240.998,242.142z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M409.6,221.867c-51.755,0-93.867,42.112-93.867,93.867c0,51.755,42.112,93.867,93.867,93.867
			c51.755,0,93.867-42.112,93.867-93.867C503.467,263.979,461.355,221.867,409.6,221.867z M409.6,392.533
			c-42.351,0-76.8-34.449-76.8-76.8s34.449-76.8,76.8-76.8s76.8,34.449,76.8,76.8S451.951,392.533,409.6,392.533z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M409.6,256c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133
			c18.825,0,34.133-15.309,34.133-34.133S428.425,256,409.6,256z M409.6,307.2c-9.412,0-17.067-7.654-17.067-17.067
			c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C426.667,299.546,419.012,307.2,409.6,307.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M434.355,341.333h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
			C376.96,405.222,393.19,409.6,409.6,409.6s32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.344,4.258-7.381V367.07
			C460.8,352.879,448.939,341.333,434.355,341.333z M443.733,384.469c-21.239,10.581-47.027,10.581-68.267,0V367.07
			c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V384.469z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M204.8,324.267c-51.755,0-93.867,42.112-93.867,93.867S153.045,512,204.8,512c51.755,0,93.867-42.112,93.867-93.867
			S256.555,324.267,204.8,324.267z M204.8,494.933c-42.351,0-76.8-34.449-76.8-76.8s34.449-76.8,76.8-76.8
			c42.351,0,76.8,34.449,76.8,76.8S247.151,494.933,204.8,494.933z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M204.8,358.4c-18.825,0-34.133,15.309-34.133,34.133c0,18.825,15.309,34.133,34.133,34.133s34.133-15.309,34.133-34.133
			C238.933,373.709,223.625,358.4,204.8,358.4z M204.8,409.6c-9.412,0-17.067-7.654-17.067-17.067
			c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C221.867,401.946,214.212,409.6,204.8,409.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M229.555,443.733h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
			C172.16,507.622,188.39,512,204.8,512s32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.343,4.258-7.381V469.47
			C256,455.279,244.139,443.733,229.555,443.733z M238.933,486.869c-21.24,10.581-47.027,10.581-68.267,0V469.47
			c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V486.869z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M93.867,110.933C42.112,110.933,0,153.045,0,204.8c0,51.755,42.112,93.867,93.867,93.867
			c51.755,0,93.867-42.112,93.867-93.867C187.733,153.045,145.621,110.933,93.867,110.933z M93.867,281.6
			c-42.351,0-76.8-34.449-76.8-76.8c0-42.351,34.449-76.8,76.8-76.8c42.351,0,76.8,34.449,76.8,76.8
			C170.667,247.151,136.218,281.6,93.867,281.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M93.867,145.067c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133
			c18.825,0,34.133-15.309,34.133-34.133S112.691,145.067,93.867,145.067z M93.867,196.267c-9.412,0-17.067-7.654-17.067-17.067
			s7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067S103.279,196.267,93.867,196.267z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M118.622,230.4h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
			c14.302,8.277,30.532,12.655,46.942,12.655c16.41,0,32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.344,4.258-7.381v-22.494
			C145.067,241.946,133.205,230.4,118.622,230.4z M128,273.536c-21.239,10.581-47.027,10.581-68.267,0v-17.399
			c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V273.536z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M298.667,0C246.912,0,204.8,42.112,204.8,93.867c0,51.755,42.112,93.867,93.867,93.867
			c51.755,0,93.867-42.112,93.867-93.867C392.533,42.112,350.421,0,298.667,0z M298.667,170.667c-42.351,0-76.8-34.449-76.8-76.8
			c0-42.351,34.449-76.8,76.8-76.8s76.8,34.449,76.8,76.8C375.467,136.218,341.018,170.667,298.667,170.667z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M298.667,34.133c-18.825,0-34.133,15.309-34.133,34.133s15.309,34.133,34.133,34.133S332.8,87.091,332.8,68.267
			S317.491,34.133,298.667,34.133z M298.667,85.333c-9.412,0-17.067-7.654-17.067-17.067c0-9.412,7.654-17.067,17.067-17.067
			s17.067,7.654,17.067,17.067C315.733,77.679,308.079,85.333,298.667,85.333z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M323.422,119.467h-49.51c-14.583,0-26.445,11.546-26.445,25.728v22.494c0,3.046,1.621,5.862,4.258,7.39
			c14.302,8.277,30.532,12.655,46.942,12.655s32.64-4.378,46.942-12.655c2.637-1.519,4.258-4.344,4.258-7.381v-22.494
			C349.867,131.012,338.005,119.467,323.422,119.467z M332.8,162.603c-21.239,10.581-47.027,10.581-68.267,0v-17.399
			c0-4.779,4.207-8.67,9.378-8.67h49.51c5.171,0,9.378,3.891,9.378,8.67V162.603z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M219.827,88.311c-3.063-3.567-8.448-3.994-12.032-0.93l-59.136,50.603c-3.584,3.063-4.002,8.448-0.939,12.032
			c1.69,1.971,4.079,2.987,6.485,2.987c1.963,0,3.934-0.674,5.547-2.057l59.136-50.603C222.473,97.28,222.891,91.895,219.827,88.311
			z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M407.893,225.289l-51.2-68.267c-2.825-3.78-8.175-4.523-11.947-1.707c-3.772,2.825-4.531,8.175-1.707,11.938l51.2,68.267
			c1.681,2.236,4.241,3.413,6.835,3.413c1.775,0,3.576-0.555,5.112-1.707C409.958,234.402,410.718,229.052,407.893,225.289z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M337.86,343.953c-2.825-3.772-8.175-4.531-11.947-1.707l-47.667,35.746c-3.772,2.825-4.531,8.175-1.707,11.938
			c1.681,2.236,4.241,3.413,6.835,3.413c1.783,0,3.575-0.563,5.112-1.707l47.667-35.746
			C339.925,353.067,340.685,347.716,337.86,343.953z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M119.467,409.6H59.733c-4.71,0-8.533,3.814-8.533,8.533s3.823,8.533,8.533,8.533h59.733c4.71,0,8.533-3.814,8.533-8.533
			S124.177,409.6,119.467,409.6z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M93.867,0C75.042,0,59.733,15.309,59.733,34.133c0,18.825,15.309,34.133,34.133,34.133
			c18.825,0,34.133-15.309,34.133-34.133C128,15.309,112.691,0,93.867,0z M93.867,51.2c-9.412,0-17.067-7.654-17.067-17.067
			c0-9.412,7.654-17.067,17.067-17.067c9.412,0,17.067,7.654,17.067,17.067C110.933,43.546,103.279,51.2,93.867,51.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M93.867,51.2c-4.71,0-8.533,3.814-8.533,8.533v59.733c0,4.719,3.823,8.533,8.533,8.533c4.71,0,8.533-3.814,8.533-8.533
			V59.733C102.4,55.014,98.577,51.2,93.867,51.2z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}
